import {downloadPrivateMedia} from '../../helpers/privateMedia';
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import UserService from "../../services/user.service";
import Container from "@material-ui/core/Container";
import {Divider} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import {NotificationManager} from "react-notifications";
import Grid from "@material-ui/core/Grid";
import Title from "../dashboard/Title";
import {Redirect} from "react-router-dom";
import {logOut} from "../../helpers/logout";
import watermark from "watermarkjs";
import wmPhoto from "../../assets/watermark.png";
import PhotoUploadCard from "./PhotoUploadCard";
import {photoFormData, photoUploadErrorMessage, validatePhotoFile} from '../../helpers/photo-upload';
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import DescriptionIcon from "@material-ui/icons/Description";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import ReceiptIcon from "@material-ui/icons/Receipt";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import WhatshotIcon from "@material-ui/icons/Whatshot";
import HowToRegIcon from "@material-ui/icons/HowToReg";
import ArchiveIcon from "@material-ui/icons/Archive";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import {getAccess} from "../../helpers/permissions";

const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    root: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper,
    },
    seeMore: {
        marginTop: theme.spacing(8),
    },
    paper: {
        padding: theme.spacing(2),
        display: "flex",
        overflow: "auto",
        flexDirection: "column",
    },
    fixedHeight: {
        height: 340,
    },
    buttonPosition: {
        position: "absolute",
        right: theme.spacing(3),
    },
    toolbarButtons: {
        marginLeft: "auto",
    },
    marginElement: {
        margin: theme.spacing(2),
    },
    marginTop: {
        marginTop: theme.spacing(2),
    },
    icon: {
        marginRight: theme.spacing(2),
    },
    heroContent: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(8, 0, 6),
    },
    heroButtons: {
        marginTop: theme.spacing(4),
    },
    buttonsAlign: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: theme.spacing(2),
        "& > *": {
            margin: theme.spacing(1),
        },
    },
    docSection: {
        padding: theme.spacing(3, 0),
        [theme.breakpoints.down("xs")]: {
            padding: theme.spacing(2, 0),
        },
    },
    docGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
        gap: theme.spacing(1.75),
        [theme.breakpoints.down("xs")]: {
            gridTemplateColumns: "1fr",
            gap: theme.spacing(1.25),
        },
    },
    docButton: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "flex-start",
        textAlign: "left",
        gap: theme.spacing(1.5),
        padding: theme.spacing(1.5, 2),
        background: "#ffffff",
        border: "1.5px solid rgba(176, 141, 87, 0.35)",
        borderRadius: 12,
        color: "#2c4767",
        fontWeight: 600,
        fontSize: "0.92rem",
        textTransform: "none",
        letterSpacing: 0.1,
        lineHeight: 1.3,
        boxShadow: "0 2px 8px rgba(44, 71, 103, 0.05)",
        transition: "background 200ms ease, color 200ms ease, border-color 200ms ease, box-shadow 200ms ease, transform 160ms ease",
        minHeight: 56,
        width: "100%",
        cursor: "pointer",
        "&:hover": {
            background: "linear-gradient(135deg, #2c4767 0%, #1e3553 100%)",
            color: "#ffffff",
            borderColor: "#2c4767",
            boxShadow: "0 10px 26px rgba(44, 71, 103, 0.25)",
            transform: "translateY(-1px)",
            "& $docButtonIcon": {
                color: "#f0d9a8",
            },
        },
        "&:active": {
            transform: "translateY(0)",
        },
        "& .MuiButton-label": {
            justifyContent: "flex-start",
            alignItems: "center",
            gap: theme.spacing(1.5),
        },
    },
    docButtonIcon: {
        width: 36,
        height: 36,
        borderRadius: 8,
        background: "rgba(176, 141, 87, 0.14)",
        color: "#b08d57",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        transition: "background 200ms ease, color 200ms ease",
    },
    docButtonLabel: {
        flex: "1 1 auto",
        whiteSpace: "normal",
        wordBreak: "break-word",
    },
    docSectionDivider: {
        margin: theme.spacing(3, 0),
        background: "linear-gradient(90deg, rgba(44, 71, 103, 0.18) 0%, rgba(176, 141, 87, 0.18) 100%)",
        height: 1,
        border: 0,
    },
    /* ---------- Dokumenty o zosnulom: photo-card grid ---------- */
    docPhotoGridWrap: {
        padding: theme.spacing(2, 0, 4, 0),
        [theme.breakpoints.up("md")]: {
            padding: theme.spacing(3, 0, 6, 0),
        },
    },
}));

export default function DocumentsDetails(props) {
    const classes = useStyles();
    const access = getAccess();

    // const [funeral, setFuneral] = useState(props.funeral);
    const { funeral, setRefetch } = props;

    const [selectedFile, setSelectedFile] = useState({
        pass_burial: null,
        other_document_1: null,
        other_document_2: null,
        other_document_3: null,
        other_document_4: null,
        hole_photo: null,
        decease_photo: null,
        passport: null,
        examination_photo_back: null,
        death_photo: null,
        examination_photo_front: null,
        take_remains_photo: null,
    });

    const [progress, setProgress] = useState({
        pass_burial: null,
        other_document_1: null,
        other_document_2: null,
        other_document_3: null,
        other_document_4: null,
        hole_photo: null,
        decease_photo: null,
        passport: null,
        examination_photo_front: null,
        examination_photo_back: null,
        death_photo: null,
        take_remains_photo: null,
    });
    const [loaded, setLoaded] = useState({
        pass_burial: null,
        other_document_1: null,
        other_document_2: null,
        other_document_3: null,
        other_document_4: null,
        hole_photo: null,
        decease_photo: null,
        passport: null,
        examination_photo_front: null,
        examination_photo_back: null,
        death_photo: null,
        take_remains_photo: null,
    });

    const [isOpen, setIsOpen] = useState({
        pass_burial: false,
        other_document_1: null,
        other_document_2: null,
        other_document_3: null,
        other_document_4: null,
        hole_photo: false,
        decease_photo: false,
        passport: false,
        examination_photo_front: false,
        examination_photo_back: false,
        death_photo: false,
        take_remains_photo: null,
    });

    const [redirects, setRedirects] = useState({
        delegationRedirect: false,
        gdprRedirect: false,
        infoList: false,
        coffinLabel: false,
        cards: false,
        prices: false,
        deliveryNoteRedirect: false,
        applicationRedirect: false,
        urnApplicationRedirect: false,
        fetalRemainsApplicationRedirect: false,
        crematoriumEvidenceListRedirect: false,
        confirmationRedirect: false,
        funeralRecordRedirect: false,
        cremationRedirect: false,
        registryOfficeRedirect: false,
        invoiceRedirect: false,
        internationalTransportRedirect: false,
        autopsyReportRequestRedirect: false,
        autopsyRefusalRedirect: false,
        representativeAutopsyRefusalRedirect: false,
        deathExaminationConfirmationRedirect: false,
    });

    const [user, setUser] = useState(null);
    const user_local = JSON.parse(localStorage.getItem("user")).id;

    useEffect(() => {
        UserService.getUser(user_local).then(
            (response) => {
                setUser(response.data);
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning(
                        "Potrebné sa znova prihlásiť!",
                        "Upozornenie",
                        5000
                    );
                }
            }
        );
    }, [user_local, props]);

    const handleRedirects = (name) => {
        setRedirects({ ...redirects, [name]: true });
    };

    const closeLightbox = (name) => () => {
        setIsOpen({ ...isOpen, [name]: !isOpen[name] });
    };

    const singleFileChangedHandler = (name) => (event) => {
        setSelectedFile({ ...selectedFile, [name]: event.target.files[0] });
        setLoaded({ ...loaded, [name]: "custom-file-upload-loaded" });
    };

    const handleProgress = (name) => (data) => {
        setProgress(current => ({
            ...current,
            [name]: data.total ? Math.round((100 * data.loaded) / data.total) : 0,
        }));
    };

    const singleFileUploadHandler = (name, withWatermark = false) => async () => {
        let file = selectedFile[name];
        const validationError = validatePhotoFile(file);
        if (validationError) {
            NotificationManager.error(photoUploadErrorMessage(validationError), 'Chyba', 5000);
            return;
        }

        setProgress(current => ({...current, [name]: 0}));
        try {
            if (withWatermark) {
                try {
                    file = await watermark([file, wmPhoto]).blob(watermark.image.atPos(getX, getY, 0));
                } catch {
                    throw Object.assign(new Error('Image processing failed'), {code: 'IMAGE_PROCESSING_FAILED'});
                }
                const processedError = validatePhotoFile(file);
                if (processedError) throw Object.assign(new Error('Invalid processed image'), {code: processedError});
            }
            await UserService.addPhoto(photoFormData(file, funeral, name), handleProgress(name));
            setRefetch(current => !current);
            setLoaded(current => ({...current, [name]: ''}));
            setSelectedFile(current => ({...current, [name]: null}));
            NotificationManager.success('Dokument úspešne uložený!', 'Uložené', 5000);
        } catch (error) {
            if (error.response?.status === 401) {
                logOut(props);
                NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
            } else {
                NotificationManager.error(photoUploadErrorMessage(error), 'Chyba', 5000);
            }
        } finally {
            setProgress(current => ({...current, [name]: null}));
        }
    };

    let getX = function (photo, logo) {
        if ((photo.width / 4) * 3 + logo.width < photo.width)
            return photo.width - logo.width;
        return (photo.width / 4) * 3;
    };

    let getY = function (photo, logo) {
        return photo.height - logo.height;
    };

    const singleFileUploadHandlerWithWaterMark = (name) => singleFileUploadHandler(name, true);

    const saveImage = (url) => async () => {
        try { await downloadPrivateMedia(url); }
        catch (error) { NotificationManager.error(error.message, 'Súbor sa nepodarilo stiahnuť.', 5000); }
    };

    const documentCard = (photo, photoText, selectedFileForKey, title, method) => (
        <PhotoUploadCard
            key={photoText}
            photo={photo}
            photoText={photoText}
            selectedFile={selectedFileForKey}
            title={title}
            onFileChange={singleFileChangedHandler(photoText)}
            onUpload={method}
            onDownload={saveImage(photo)}
            isLightboxOpen={isOpen[photoText]}
            onToggleLightbox={closeLightbox(photoText)}
            uploadProgress={progress[photoText]}
            canUpload={access.write}
        />
    );

    const DocButton = ({Icon, label, onClick}) => (
        <Button className={classes.docButton} onClick={onClick} disableRipple={false}>
            <span className={classes.docButtonIcon}>
                <Icon fontSize="small"/>
            </span>
            <span className={classes.docButtonLabel}>{label}</span>
        </Button>
    );

    return (
        <React.Fragment>
            <Title>Dokumenty na generovanie</Title>
            <div className={classes.docSection}>
                <div className={classes.docGrid}>
                    <DocButton
                        Icon={AssignmentIndIcon}
                        label="Splnomocnenie"
                        onClick={() => handleRedirects("registryOfficeRedirect")}
                    />
                    <DocButton
                        Icon={DescriptionIcon}
                        label="Záznam o pohrebe"
                        onClick={() => handleRedirects("funeralRecordRedirect")}
                    />
                    <DocButton
                        Icon={InfoOutlinedIcon}
                        label="Informačný list k pohrebu"
                        onClick={() => handleRedirects("infoList")}
                    />
                    <DocButton
                        Icon={BorderColorIcon}
                        label="Dokumenty na podpis"
                        onClick={() => handleRedirects("gdprRedirect")}
                    />
                    <DocButton
                        Icon={ReceiptIcon}
                        label="Potvrdenie"
                        onClick={() => handleRedirects("confirmationRedirect")}
                    />
                    {access.seePrices && <DocButton
                        Icon={LocalAtmIcon}
                        label="Informačné ceny"
                        onClick={() => handleRedirects("prices")}
                    />}
                    <DocButton
                        Icon={WhatshotIcon}
                        label="Povolenie na kremáciu"
                        onClick={() => handleRedirects("cremationRedirect")}
                    />
                    <DocButton
                        Icon={HowToRegIcon}
                        label="Žiadosť o príspevok na pohreb"
                        onClick={() => handleRedirects("applicationRedirect")}
                    />
                    <DocButton
                        Icon={ArchiveIcon}
                        label="Žiadosť o vydanie povolenia na uloženie urny"
                        onClick={() => handleRedirects("urnApplicationRedirect")}
                    />
                    <DocButton
                        Icon={DescriptionIcon}
                        label="Žiadosť rodiča o vydanie potrateného ľudského plodu"
                        onClick={() => handleRedirects("fetalRemainsApplicationRedirect")}
                    />
                    <DocButton
                        Icon={DescriptionIcon}
                        label="Evidenčný list pre Krematórium"
                        onClick={() => handleRedirects("crematoriumEvidenceListRedirect")}
                    />
                    <DocButton
                        Icon={LocalShippingIcon}
                        label="Medzinárodný prepravný formulár zosnulého"
                        onClick={() => handleRedirects("internationalTransportRedirect")}
                    />
                    <DocButton
                        Icon={DescriptionIcon}
                        label="Žiadosť o vydanie podrobnej pitevnej správy"
                        onClick={() => handleRedirects("autopsyReportRequestRedirect")}
                    />
                    <DocButton
                        Icon={DescriptionIcon}
                        label="Odmietnutie pitvy"
                        onClick={() => handleRedirects("autopsyRefusalRedirect")}
                    />
                    <DocButton
                        Icon={DescriptionIcon}
                        label="Odmietnutie pitvy - zákonný zástupca"
                        onClick={() => handleRedirects("representativeAutopsyRefusalRedirect")}
                    />
                    <DocButton
                        Icon={DescriptionIcon}
                        label="Potvrdenie o prehliadke mŕtveho tela"
                        onClick={() => handleRedirects("deathExaminationConfirmationRedirect")}
                    />
                </div>
                <hr className={classes.docSectionDivider}/>
                <div className={classes.docGrid}>
                    {access.seePrices && user && user.iban && user.next_invoice_number && (
                        <DocButton
                            Icon={ReceiptIcon}
                            label="Faktúra"
                            onClick={() => handleRedirects("invoiceRedirect")}
                        />
                    )}
                    <DocButton
                        Icon={LocalOfferIcon}
                        label="Štítok na rakvu"
                        onClick={() => handleRedirects("coffinLabel")}
                    />
                    {user?.premium && (
                        <DocButton
                            Icon={CreditCardIcon}
                            label="Kartičky"
                            onClick={() => handleRedirects("cards")}
                        />
                    )}
                    {access.seePrices && user && user.iban && user.next_invoice_number && (
                        <DocButton
                            Icon={LocalShippingIcon}
                            label="Dodací list"
                            onClick={() => handleRedirects("deliveryNoteRedirect")}
                        />
                    )}
                </div>
            </div>
            <Divider/>
            <Title>Dokumenty o zosnulom</Title>
            <Container className={classes.docPhotoGridWrap} maxWidth="lg" disableGutters>
                <Grid container spacing={3}>
                    {documentCard(
                        funeral.examination_photo_front,
                        "examination_photo_front",
                        selectedFile.examination_photo_front,
                        "List o prehliadke mŕtveho predná strana",
                        singleFileUploadHandler("examination_photo_front")
                    )}
                    {documentCard(
                        funeral.examination_photo_back,
                        "examination_photo_back",
                        selectedFile.examination_photo_back,
                        "List o prehliadke mŕtveho zadná strana",
                        singleFileUploadHandler("examination_photo_back")
                    )}
                    {documentCard(
                        funeral.death_photo,
                        "death_photo",
                        selectedFile.death_photo,
                        "Úmrtný list",
                        singleFileUploadHandler("death_photo")
                    )}
                    {documentCard(
                        funeral.decease_photo,
                        "decease_photo",
                        selectedFile.decease_photo,
                        "Fotka zosnulého",
                        singleFileUploadHandlerWithWaterMark("decease_photo")
                    )}
                    {documentCard(
                        funeral.hole_photo,
                        "hole_photo",
                        selectedFile.hole_photo,
                        "Fotka výkopu hrobu",
                        singleFileUploadHandler("hole_photo")
                    )}
                    {documentCard(
                        funeral.passport,
                        "passport",
                        selectedFile.passport,
                        "Pas pre mŕtvolu",
                        singleFileUploadHandler("passport")
                    )}
                    {documentCard(
                        funeral.pass_burial,
                        "pass_burial",
                        selectedFile.pass_burial,
                        "Povolenie na pochovanie",
                        singleFileUploadHandler("pass_burial")
                    )}
                    {documentCard(
                        funeral.take_remains_photo,
                        "take_remains_photo",
                        selectedFile.take_remains_photo,
                        "Odovzdanie ľudských pozostatkov",
                        singleFileUploadHandler("take_remains_photo")
                    )}
                    {documentCard(
                        funeral.other_document_1,
                        "other_document_1",
                        selectedFile.other_document_1,
                        "Iné dokumenty 1",
                        singleFileUploadHandler("other_document_1")
                    )}
                    {documentCard(
                        funeral.other_document_2,
                        "other_document_2",
                        selectedFile.other_document_2,
                        "Iné dokumenty 2",
                        singleFileUploadHandler("other_document_2")
                    )}
                    {documentCard(
                        funeral.other_document_3,
                        "other_document_3",
                        selectedFile.other_document_3,
                        "Iné dokumenty 3",
                        singleFileUploadHandler("other_document_3")
                    )}
                    {documentCard(
                        funeral.other_document_4,
                        "other_document_4",
                        selectedFile.other_document_4,
                        "Iné dokumenty 4",
                        singleFileUploadHandler("other_document_4")
                    )}
                </Grid>
            </Container>
            {redirects.applicationRedirect ? (
                <Redirect
                    to={{
                        pathname: `/pohreb/${funeral._id}/ziadost`,
                        state: { from: props.location },
                    }}
                />
            ) : (
                <></>
            )}
            {redirects.urnApplicationRedirect ? (
                <Redirect
                    to={{
                        pathname: `/pohreb/${funeral._id}/ziadost_urna`,
                        state: { from: props.location },
                    }}
                />
            ) : (
                <></>
            )}
            {redirects.fetalRemainsApplicationRedirect ? (
                <Redirect
                    to={{
                        pathname: `/pohreb/${funeral._id}/ziadost-plod`,
                        state: { from: props.location },
                    }}
                />
            ) : (
                <></>
            )}
            {redirects.crematoriumEvidenceListRedirect ? (
                <Redirect
                    to={{
                        pathname: `/pohreb/${funeral._id}/evidencny-list`,
                        state: { from: props.location },
                    }}
                />
            ) : (
                <></>
            )}
            {redirects.internationalTransportRedirect ? (
                <Redirect
                    to={{
                        pathname: `/pohreb/${funeral._id}/medzinarodny_prepravny_formular`,
                        state: { from: props.location },
                    }}
                />
            ) : (
                <></>
            )}
            {redirects.autopsyReportRequestRedirect ? (
                <Redirect
                    to={{
                        pathname: `/pohreb/${funeral._id}/ziadost_o_pitevnu_spravu`,
                        state: { from: props.location },
                    }}
                />
            ) : (
                <></>
            )}
            {redirects.autopsyRefusalRedirect ? (
                <Redirect
                    to={{
                        pathname: `/pohreb/${funeral._id}/odmietnutie-pitvy`,
                        state: { from: props.location },
                    }}
                />
            ) : (
                <></>
            )}
            {redirects.representativeAutopsyRefusalRedirect ? (
                <Redirect
                    to={{
                        pathname: `/pohreb/${funeral._id}/odmietnutie-pitvy-zakonny-zastupca`,
                        state: { from: props.location },
                    }}
                />
            ) : (
                <></>
            )}
            {redirects.deathExaminationConfirmationRedirect ? (
                <Redirect
                    to={{
                        pathname: `/pohreb/${funeral._id}/potvrdenie-o-prehliadke-mrtveho-tela`,
                        state: { from: props.location },
                    }}
                />
            ) : (
                <></>
            )}
            {redirects.confirmationRedirect ? (
                <Redirect
                    to={{
                        pathname: `/pohreb/${funeral._id}/potvrdenie`,
                        state: { from: props.location },
                    }}
                />
            ) : (
                <></>
            )}
            {redirects.funeralRecordRedirect ? (
                <Redirect
                    to={{
                        pathname: `/pohreb/${funeral._id}/zaznam_o_pohrebe`,
                        state: { from: props.location },
                    }}
                />
            ) : (
                <></>
            )}
            {redirects.cremationRedirect ? (
                <Redirect
                    to={{
                        pathname: `/pohreb/${funeral._id}/povolenie_na_kremaciu`,
                        state: { from: props.location },
                    }}
                />
            ) : (
                <></>
            )}
            {redirects.registryOfficeRedirect ? (
                <Redirect
                    to={{
                        pathname: `/pohreb/${funeral._id}/sprava_pre_matriku`,
                        state: { from: props.location },
                    }}
                />
            ) : (
                <></>
            )}
            {redirects.invoiceRedirect ? (
                <Redirect
                    to={{
                        pathname: `/pohreb/${funeral._id}/faktura`,
                        state: { from: props.location },
                    }}
                />
            ) : (
                <></>
            )}
            {redirects.deliveryNoteRedirect ? (
                <Redirect
                    to={{
                        pathname: `/pohreb/${funeral._id}/dodaci_list`,
                        state: { from: props.location },
                    }}
                />
            ) : (
                <></>
            )}
            {redirects.delegationRedirect ? (
                <Redirect
                    to={{
                        pathname: `/pohreb/${funeral._id}/splnomocnenie`,
                        state: { from: props.location },
                    }}
                />
            ) : (
                <></>
            )}
            {redirects.gdprRedirect ? (
                <Redirect
                    to={{
                        pathname: `/pohreb/${funeral._id}/gdpr`,
                        state: { from: props.location },
                    }}
                />
            ) : (
                <></>
            )}
            {redirects.infoList ? (
                <Redirect
                    to={{
                        pathname: `/pohreb/${funeral._id}/informacny_list`,
                        state: { from: props.location },
                    }}
                />
            ) : (
                <></>
            )}
            {redirects.coffinLabel ? (
                <Redirect
                    to={{
                        pathname: `/pohreb/${funeral._id}/stitok_rakva`,
                        state: { from: props.location },
                    }}
                />
            ) : (
                <></>
            )}
            {redirects.cards ? (
                <Redirect
                    to={{
                        pathname: `/pohreb/${funeral._id}/karticky`,
                        state: { from: props.location },
                    }}
                />
            ) : (
                <></>
            )}
            {redirects.prices ? (
                <Redirect
                    to={{
                        pathname: `/pohreb/${funeral._id}/cennik`,
                        state: { from: props.location },
                    }}
                />
            ) : (
                <></>
            )}
        </React.Fragment>
    );
}
